import React from "react";
import "./BreadCrumb.scss";
export type seprator = "/" | ">" | "-";
export interface Props {
  // custom?: boolean;
  // data?: any;
  seprator?: seprator;
  className?: string;
  homeLabel?: string;
  // homePath?: string;
}
const BreadCrumb = ({
  seprator = "/",
  className = "",
  homeLabel = "Home",
}: Props) => {
  const pathSegments = window.location.pathname
    .split("/")
    .filter((segment) => segment)
    .map((segment, index, array) => {
      const url = `/${array.slice(0, index + 1).join("/")}`;
      return { name: decodeURIComponent(segment), url };
    });

  return (
    <>
       <nav
          aria-label="breadcrumb"
          className={`mfg-breadcrumbs${className ? " " + className : ""}`}
        >
          <ul>
            <li key={homeLabel}>
            <a href="/">{homeLabel}</a>
            </li>
            {pathSegments.map((segment, index) => {
              const isLast = index === pathSegments.length - 1;
              return (
                <li
                  key={index}
                  aria-current={isLast ? "page" : undefined}
                  className={`breadcrumb-item${isLast ? " active" : ""}`}
                >
                  <span className="mx-2">{seprator}</span>
                  {!isLast ? (
                    <a href={segment.url}>{segment.name}</a>
                  ) : (
                    <span>{segment.name}</span>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>
      {/* {custom ? (
        <nav
          aria-label="breadcrumb"
          className={`mfg-breadcrumbs${className ? " " + className : ""}`}
        >
          <ul>
            {data.map((item: any, index: number) => {
              const { label, link } = item;
              const isLast = index === data.length - 1;
              return (
                <>
                  <li
                    key={label}
                    className={`breadcrumb-item${isLast ? " active" : ""}`}
                  >
                    {isLast ? label : <Link to={link}>{label}</Link>}
                  </li>
                  {!isLast && (
                    <li>
                      {" "}
                      <span> {seprator}</span>
                    </li>
                  )}
                </>
              );
            })}
          </ul>
        </nav>
      ) : (
       
      )} */}
    </>
  );
};

export default BreadCrumb;
